@use '../../styling/typography.scss' as *;
@use '../../styling/form-controls.scss' as *;
@use '../../styling/colors.scss' as *;

$arrow-svg-gray: url('../../styling/svg/HiChevronDown.svg');

.TagInput {
  @extend %font-family-primary;

  display: block;
  width: 100%;
  position: relative;

  ::placeholder {
    color: $theme-placeholder-text;
    font-family: 'Open Sans', sans-serif;
  }

  [role='listbox'] {
    margin: 0;
    padding: 0;
  }

  &[aria-expanded='true'] [role='listbox'] {
    background-color: $theme-dropdown-background-color;
    padding: 12px 0;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top: 0;
    border: 1px solid $theme-color-borders;
    box-shadow: 0 4px 16px 0 $theme-color-shadow;
    flex-direction: column;
    left: -1px;
    list-style-type: none;
    position: absolute;
    width: 100%;
    max-height: 300px;
    overflow: auto;
    z-index: 2;
    margin-top: 4px;

    >li {
      padding: 10px 16px;
      font-weight: 600;

      &[aria-selected='true'] {
        background: $theme-dropdown-selected-value;
      }
    }
  }

  input {
    @extend %form-control-border;
    @extend %form-control-disabled;
    @extend %form-control-font;

    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    padding: 3px 24px 3px 12px;
    height: 30px;
    width: 100%;
    font-size: $font-size-normal;
    box-sizing: border-box;
    background-image:$arrow-svg-gray, linear-gradient(to left, $theme-dropdown-background-color 36px, $theme-dropdown-background-color 0);
    background-repeat: no-repeat;
    background-position: right 7px top 50%, 0 0;
    background-size: 18px auto, 100%;

    &.emptyValueStyle {
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
    }

    &::placeholder {
      color: $theme-placeholder-text;
      font-family: 'Open Sans', sans-serif;
    }

    &:focus {
      outline: none;
    }

    &.InputTextDisabled {
      background-image: $arrow-svg-gray, linear-gradient(to left, $theme-color-table-header-footer 24px, $theme-color-table-header-footer 0);
    }
  }

  .ErrorMessage {
    @extend %form-control-invalid-font;

    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    column-gap: 6px;
    padding: 8px 12px;
    font-size: $font-size-normal;
    // error message should be control by developer instead of system generate?
    // word-break: break-all;

    .ErrorIcon {
      align-self: baseline;
      margin-top: 3px;
    }
  }
}
